"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatPromptSchema = exports.chatProviderConfigSchema = exports.chatMessageSchema = exports.chatResponseSchema = exports.chatUsageSchema = exports.conversationThreadListResponseSchema = exports.conversationThreadSchema = exports.conversationMessageSchema = exports.conversationMessageRoleSchema = exports.conversationScopeSchema = void 0;
const zod_1 = require("zod");
const devices_1 = require("./devices");
exports.conversationScopeSchema = zod_1.z.enum(["admin", "user"]);
exports.conversationMessageRoleSchema = zod_1.z.enum([
    "system",
    "assistant",
    "user",
]);
const metadataSchema = zod_1.z
    .union([
    zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()),
    zod_1.z.array(zod_1.z.unknown()),
    zod_1.z.string(),
    zod_1.z.null(),
])
    .optional();
exports.conversationMessageSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    threadId: zod_1.z.string(),
    role: exports.conversationMessageRoleSchema,
    scope: exports.conversationScopeSchema.optional(),
    senderId: zod_1.z.string().nullable().optional(),
    body: zod_1.z.string(),
    metadata: metadataSchema,
    createdAt: zod_1.z.string(),
})
    .strict();
exports.conversationThreadSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    title: zod_1.z.string().nullable().optional(),
    deviceId: zod_1.z.string().nullable().optional(),
    createdBy: zod_1.z.string().nullable().optional(),
    scope: exports.conversationScopeSchema,
    status: zod_1.z.string(),
    metadata: metadataSchema,
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
    messages: zod_1.z.array(exports.conversationMessageSchema).optional(),
})
    .strict();
exports.conversationThreadListResponseSchema = zod_1.z.array(exports.conversationThreadSchema.extend({
    messages: zod_1.z.array(exports.conversationMessageSchema).optional(),
}));
exports.chatUsageSchema = zod_1.z
    .object({
    prompt_tokens: zod_1.z.number().int().nonnegative(),
    completion_tokens: zod_1.z.number().int().nonnegative(),
    total_tokens: zod_1.z.number().int().nonnegative(),
})
    .strict();
exports.chatResponseSchema = zod_1.z
    .object({
    reply: zod_1.z.string(),
    alerts: zod_1.z.array(zod_1.z.string()).optional(),
    suggestions: zod_1.z.array(devices_1.deviceRecommendationSchema).optional(),
    providerId: zod_1.z.string().optional(),
    modelId: zod_1.z.string().optional(),
    usage: exports.chatUsageSchema.optional(),
})
    .strict();
exports.chatMessageSchema = zod_1.z
    .object({
    role: exports.conversationMessageRoleSchema,
    content: zod_1.z.string(),
})
    .strict();
exports.chatProviderConfigSchema = zod_1.z
    .object({
    apiKey: zod_1.z.string().min(1).optional(),
    endpoint: zod_1.z.string().min(1).optional(),
})
    .strict();
exports.chatPromptSchema = zod_1.z
    .object({
    tenantId: zod_1.z.string(),
    scope: exports.conversationScopeSchema,
    threadId: zod_1.z.string().optional(),
    providerId: zod_1.z.string().optional(),
    modelId: zod_1.z.string().optional(),
    providerConfig: exports.chatProviderConfigSchema.optional(),
    messages: zod_1.z.array(exports.chatMessageSchema),
    metadata: metadataSchema,
})
    .strict();
